'use strict';
import cloneDeep from 'lodash/cloneDeep';
import isFunction from 'lodash/isFunction';
import isObject from 'lodash/isObject';
import {SortMethod} from './SortMethod';

export class FilterDialogController {
  static $inject = [
    '$modal',
    '$scope',
    'defaultFilterOptions',
    'defaultSortOptions',
    'filterOptions',
    'sortOptions',
  ];

  constructor(
    $modal,
    $scope,
    defaultFilterOptions,
    defaultSortOptions,
    filterOptions,
    sortOptions,
  ) {
    // expose dependencies
    this.$modal = $modal;
    this.$scope = $scope;
    this.defaultFilterOptions = defaultFilterOptions;
    this.defaultSortOptions = defaultSortOptions;

    // init controller
    const vm = $scope.filterDialog = {};

    vm.SORT_METHODS = SortMethod;
    vm.updateSort = this.updateSort.bind(this);
    vm.getSortIconClass = this.getSortIconClass.bind(this);

    vm.checked = this.checked.bind(this);
    vm.toggleAll = this.toggleAll.bind(this);
    vm.reset = this.reset.bind(this);
    vm.submitData = this.submitData.bind(this);
    vm.cancelModal = this.cancelModal.bind(this);

    vm.filterOptions = cloneDeep(filterOptions);
    vm.sortOptions = sortOptions ? cloneDeep(sortOptions) : void 0;
    vm.showAll = {};

    this.vm = vm;
    this.allWatcher = {};
    this.initTypes(filterOptions, this.allWatcher);

    $scope.$on('modal.hidden', function onHide() {
      document.getElementById("search-filter").blur();
    });
  }

  initTypes(options) {
    this.types = {};

    for (let type in options) {
      if (options.hasOwnProperty(type) && isObject(options[type])) {
        this.types[type] = Object.keys(options[type]);
        this.startAllWatcher(type);
      }
    }
  }

  updateSort(property) {
    if (!this.defaultSortOptions)
      return;

    if (this.vm.sortOptions.property === property) {
      const method = SortMethod.valueOf(this.vm.sortOptions.currentMethod);
      this.vm.sortOptions.currentMethod = method ? SortMethod.getNext(method).name : SortMethod.ASCENDING.name;
    } else {
      this.vm.sortOptions.currentMethod = SortMethod.ASCENDING.name;
    }
    this.vm.sortOptions.property = property;
  }

  getSortIconClass(property) {
    if (!this.defaultSortOptions)
      return;

    if (this.vm.sortOptions.property === property) {
      if (SortMethod.valueOf(this.vm.sortOptions.currentMethod) === SortMethod.ASCENDING) {
        return 'ion-arrow-down-c';
      } else if (SortMethod.valueOf(this.vm.sortOptions.currentMethod) === SortMethod.DESCENDING) {
        return 'ion-arrow-up-c';
      }
    }
    return '';
  }

  /**
   * 1) All checked:
   *    check none
   *
   * 2) Some checked:
   *    check all
   *
   * 3) None checked:
   *    check all
   *
   * type {string} the option key being toggled
   * forceAll {boolean} if true, sets everything to true regardless
   */
  toggleAll(type, forceAll) {
    this.stopAllWatcher(type);
    let checkedCount;
    let includeReq;

    if (forceAll) {
      includeReq = true;
    } else {
      checkedCount = this.checked(type);

      includeReq = (checkedCount === 0 || checkedCount < this.types[type].length);

      this.vm.showAll[type] = includeReq;
    }

    let i = this.types[type].length;
    while (i--) {
      this.vm.filterOptions[type][this.types[type][i]] = includeReq;
    }

    this.startAllWatcher(type);
  }

  checked(type) {
    let checkedCount = 0;

    let i = this.types[type].length;
    while (i--) {
      checkedCount += this.vm.filterOptions[type][this.types[type][i]] ? 1 : 0;
    }

    return checkedCount;
  }

  startAllWatcher(type) {
    this.allWatcher[type] = this.$scope.$watch(this.checked.bind(this, type), newValue => {
      if (!newValue) return;

      this.vm.showAll[type] = newValue === this.types[type].length;
    }, true);
  }

  stopAllWatcher(type) {
    isFunction(this.allWatcher[type]) && this.allWatcher[type]();
  }

  reset() {
    this.vm.filterOptions = cloneDeep(this.defaultFilterOptions);

    if (this.defaultSortOptions)
      this.vm.sortOptions = cloneDeep(this.defaultSortOptions);
  }

  submitData() {
    const result = {
      filterOptions: this.vm.filterOptions,
    };

    if (this.defaultSortOptions)
      result.sortOptions = this.vm.sortOptions;

    this.$modal.hide(result);
  }

  cancelModal() {
    this.$modal.cancel();
  }
}



// WEBPACK FOOTER //
// ./src/js/core-utilities/filters/FilterDialogController.js